

  
const content = `# Release Notes for Version 2.0.48
Version 2.0.48 is released with a new version of the OnData Encryption Tool. On Windows platform, the OnData Encryption Tool comes with 
a user interface and a Microsoft Windows Installer (MSI) to install the application. On Linux platform, a console version of the OnData Encryption Tool 
is available for user interactions. The version 2.x of the OnData Encryption Tool combines multiple steps of the process into a single workflow. Users 
can conveniently add a database, backup or update the database schema, and encrypt the database using the tool, without manually managing the 
configuration files. Please refer to the [**Encryption Tool Version 2**](reference_doc#how-to_guides/encryption/encryption_tool_v2) page on how to use 
the new version of the OnData Encryption Tool.  
  
Below is a summary of the changes for version 2.0.48:
* Provide OnData Encryption Tool version 2 to significantly enhance the user experience and reduce the number of manual steps.  
* Allow to copy the classification and encryption rules from one table to another. 
* Logout a user from a custom Identity Provider if the logout URL is configured at OnData Portal. 
* Notify the System Administrators of a customer account on new registrations. When a new user from an existing organization registers for OnData, 
the System Administrators of that organization will be notified so that they can invite this new user as appropriate.  
* Some minor feature enhancements and bug fixes.  
`
  
export default content;
